import React, { useState } from 'react'

import { Faq, FaqQuestionType } from 'components'
import { AnimatedForm, Button, Form, FormFieldType } from 'shared/components'
import { emailValidator, phoneValidator } from 'shared/utils/validators'

import classes from './CooperationForm.module.scss'
import { FormTypes } from 'models'

const formId = 'cooperation-partners'

const formats = [
  'DOC',
  'DOCX',
  'TXT',
  'RTF',
  'HTML',
  'ODT',
  'PPT',
  'PPTX',
  'PDF',
  'XLS',
  'XLSX',
]

const fields: FormFieldType[] = [
  {
    type: 'input',
    label: 'Компания',
    placeholder: 'Введите название компании',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'company',
    required: true,
    maxSize: 50,
  },
  {
    type: 'input',
    label: 'Должность',
    placeholder: 'Введите должность',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'position',
    required: true,
    maxSize: 50,
  },
  {
    type: 'input',
    label: 'Фамилия',
    placeholder: 'Введите фамилию',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'surname',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    label: 'Имя',
    placeholder: 'Введите имя',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'name',
    maxSize: 50,
    required: true,
  },
  {
    type: 'input',
    placeholder: 'Введите email',
    label: 'E-mail для связи',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'email',
    validatorFn: emailValidator,
    required: true,
  },
  {
    type: 'input',
    label: 'Телефон для связи',
    placeholder: '+7 (916) 999-99-99',
    mask: '+7 (999) 999-99-99',
    colClasses: 'col-xs-12 col-sm-6 mb-2',
    name: 'phone',
    validatorFn: phoneValidator,
    required: true,
  },
  {
    type: 'textarea',
    placeholder: 'Введите сообщение',
    label: 'Сообщение',
    colClasses: 'col-xs-12 col-sm-12 mb-2',
    name: 'message',
    maxSize: 1000,
    required: true,
  },
  {
    type: 'file',
    placeholder: '',
    label: '',
    colClasses: 'col-xs-12 mb-2',
    name: 'files',
    required: false,
    maxSize: 5242880,
    maxLength: 5,
    description:
      'Не более 5 файлов. Размер файлов: не более 5 MB. Формат файлов: PDF, DOC, DOCX',
    allowFormat: formats,
    tooltipText: `Допустимый формат файлов: ${formats}`,
  },
]

const FaqQuestions: FaqQuestionType[] = [
  {
    title:
      'Можно ли заинтересовать вас сотрудничеством, предлагая только сценарий проекта?',
    children:
      'Безусловно. Хороший сценарий является одним из главных составляющих успеха сериала или фильма.',
  },
  {
    title: 'Может ли физическое лицо, а не компания, стать вашим партнером?',
    children:
      'Да. Мы сотрудничаем как с юридическими, так и с физическими лицами - гражданами России, достигшими 18 лет.',
  },
]

export const CooperationForm = (): JSX.Element => {
  const [formOpened, setFormOpened] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)

  const handleSubmit = () => {
    setIsSubmit(true)
  }

  const handleClose = () => {
    setIsSubmit(false)
    setFormOpened(false)
  }

  return (
    <div className="container reveal-from-bottom-medium" data-reveal-delay={30}>
      <Faq
        questions={FaqQuestions}
        title="Частые вопросы"
        titleUppercase
        isReveal={false}
      />

      <div className={`${classes.bg}`}>
        <div className="row">
          <div className="col-xs-12 col-md-12 col-lg-9">
            <h2 className={`${classes.title} weight-bold uppercase`}>
              Готовы к сотрудничеству?
            </h2>
            <p className={classes.text}>
              Для начала требуется регистрация на официальном сайте закупок. Нам
              важно, <br /> чтобы все было честно и прозрачно для всех.
            </p>
          </div>
          <div className={`col-xs-12 col-md-12 col-lg-3 ${classes.btn}`}>
            <Button onClick={() => setFormOpened(true)}>Стать партнером</Button>
          </div>
        </div>
      </div>

      <AnimatedForm id={formId} open={formOpened} scrollCenter={isSubmit}>
        <Form
          showed={formOpened}
          id={formId}
          fields={fields}
          title="Стать партнером"
          titleLarge
          showUserAgreement
          onCloseClick={() => handleClose()}
          onAutoClose={() => handleClose()}
          formClasses={classes.form}
          onSubmit={() => handleSubmit()}
          type={FormTypes.Filmmaking}
        />
      </AnimatedForm>
    </div>
  )
}
